<div class="benchmark-container">
  <div class="benchmark-header">
    <h3 class="benchmark-title">{{ title }}</h3>
  </div>

  <div class="benchmark-content">
    <div class="dropdown-container">
      <label for="benchmark-select">Select Benchmark Option:</label>
      <select id="benchmark-select" class="benchmark-dropdown" [(ngModel)]="selectedOption"
        (change)="onOptionChange($event)" [disabled]="isLoadingOptions">
        <option value="" disabled>
          {{ isLoadingOptions ? 'Loading options...' : 'Choose an option' }}
        </option>
        <option *ngFor="let option of benchmarkOptions" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
      <div *ngIf="isLoadingOptions" class="loading-indicator">
        Loading benchmark options...
      </div>
    </div>
    <div *ngIf="showSelectError" class="error-message">
      Please select a benchmark option before proceeding.
    </div>
  </div>

  <!-- Dialog Actions - always show when used as overlay -->
  <div class="dialog-actions">
    <button type="button" class="btn-closebenchmark" (click)="closeBenchmark()">
      Close
    </button>
    <button id = "procedbenchmark-download" type="button" class="btn-procedbenchmark-download" (click)="proceedWithDownload()" [disabled]="isLoadingOptions">
      Proceed with Download
    </button>
  </div>
</div>